import React  from 'react';

const CopyrightText = () => {
  const year = new Date().getFullYear();

  return (
    <>
      © 2015-{year} Copyright School Hire Lettings Ltd (formerly School Lettings Ltd)
      <br/>
      All rights reserved.
      <a href="/terms_and_conditions">T&amp;C and Policies</a>
    </>
  )
};

export default CopyrightText;
